import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import "./LoginPage.css";
// import { loginUser } from "../../services/auth/AuthAPI";
import {Button, Form, Spin} from "antd";
import {loginUser} from "../../services/auth/AuthAPI";

function LoginPage(props: any) {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [error, setError] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        localStorage.clear();
    }, []);
    const formItemLayout = {
        labelCol: {span: 4},
        wrapperCol: {span: 20},
    };
    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            await loginUser(values.username, values.password);
            setLoading(false);
            navigate("/single-search");
        } catch (error: any) {
            setError(error.message);
            setLoading(false);
        }
    };
    return (
        <div className="login-main-container container-fluid">
            <div className="login-container">
                <h3 className="login-title">Login</h3>
                <Spin spinning={loading}>
                    <div className="login-wrapper border-shadow-container">
                        <Form
                            {...formItemLayout}
                            onFinish={onFinish}
                            colon={false}
                            form={form}
                            style={{width: "100%"}}>
                            <Form.Item
                                label="Username"
                                name={"username"}
                                required
                                rules={[{required: true, message: "Please input your username!"}]}
                                labelAlign="left">
                                <input
                                    type="text"
                                    className="form-control"
                                />
                            </Form.Item>
                            <Form.Item
                                label="Password"
                                name={"password"}
                                required
                                rules={[{required: true, message: "Please input your password!"}]}
                                labelAlign="left">
                                <input
                                    type="password"
                                    className="form-control"
                                />
                            </Form.Item>
                            <div className="d-flex flex-column gap-4 w-100">
                                <span style={{color: "red", width: "100%"}}>{error}</span>
                                <Form.Item label={null}>
                                      <Button type="primary" htmlType="submit" onClick={() => form.submit()} style={{justifySelf: "center", alignSelf: "center"}}>
                                        Login
                                      </Button>
                                </Form.Item>
                            </div>
                            {/*<button*/}
                            {/*    className="button"*/}
                            {/*    style={{justifySelf: "center", alignSelf: "center"}}*/}
                            {/*    onClick={() => form.submit()}>*/}
                            {/*    Login*/}
                            {/*</button>*/}
                        </Form>
                    </div>
                </Spin>
            </div>
        </div>
    );
}

export default LoginPage;
